export const logout = () => {
  // Set a flag to indicate intentional logout
  localStorage.setItem("isLoggingOut", "true");

  // Remove auth tokens
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");

  // Redirect to signin page
  window.location.href = "/signin";
};
